(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[5],{

/***/ "dYvW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCategoryTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPropertyTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPropertyTreeForProject; });
/* unused harmony export getOwnerPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getListingDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getQuickFilterSuggest; });
/* unused harmony export getQuickFilterApply */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getQuickFilterURL; });
/* unused harmony export listingSearch */
/* unused harmony export getListingSearchPageData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getListingSearchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getShowcaseListings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getProjectListingSearchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getNearbyPOIs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSimilarListings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getNearByListings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return viewListingDetailEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return handleViewPhoneEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getSameRealEstate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getRegionPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getShowcaseData; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("g33+");





var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var getCategoryTree = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/mobile/category-tree")).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCategoryTree() {
    return _ref.apply(this, arguments);
  };
}();
var getPropertyTree = /*#__PURE__*/function () {
  var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(_ref2) {
    var categoryId, tradeTypeId, estateTypeId;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            categoryId = _ref2.categoryId, tradeTypeId = _ref2.tradeTypeId, estateTypeId = _ref2.estateTypeId;
            return _context2.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v2/listing/filter/fields"), {
              params: {
                categoryId: categoryId,
                tradeTypeId: tradeTypeId,
                estateTypeId: estateTypeId
              }
            }).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getPropertyTree(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var getPropertyTreeForProject = /*#__PURE__*/function () {
  var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(_ref4) {
    var categoryId, tradeTypeId, estateTypeId;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            categoryId = _ref4.categoryId, tradeTypeId = _ref4.tradeTypeId, estateTypeId = _ref4.estateTypeId;
            return _context3.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.ref, "/e6t/v1/project/filter/fields"), {
              params: {
                categoryId: categoryId,
                tradeTypeId: tradeTypeId,
                estateTypeId: estateTypeId
              }
            }).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getPropertyTreeForProject(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
var getOwnerPhone = /*#__PURE__*/function () {
  var _ref6 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee4(listingId) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/listings/").concat(listingId, "/phone")));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getOwnerPhone(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var getListingDetail = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee5(listingId) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/detail/").concat(listingId)).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getListingDetail(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
var getQuickFilterSuggest = /*#__PURE__*/function () {
  var _ref8 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee6(path) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/quick-filter/suggest/url").concat(path)).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getQuickFilterSuggest(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
var getQuickFilterApply = /*#__PURE__*/function () {
  var _ref10 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee7(_ref9) {
    var param, option;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            param = _ref9.param, option = _ref9.option;
            return _context7.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/quick-filter/suggest/apply").concat(param), option));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getQuickFilterApply(_x6) {
    return _ref10.apply(this, arguments);
  };
}();
var getQuickFilterURL = /*#__PURE__*/function () {
  var _ref11 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee8(criteria) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v2/listing/quick-filter/suggest/apply"), criteria).then(function (response) {
              return response;
            })["catch"](function (error) {
              return error.response.data;
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getQuickFilterURL(_x7) {
    return _ref11.apply(this, arguments);
  };
}();
var listingSearch = /*#__PURE__*/function () {
  var _ref12 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee9() {
    var url,
        _args9 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            url = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : '';
            return _context9.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/homepage/showcase").concat(url)).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function listingSearch() {
    return _ref12.apply(this, arguments);
  };
}();
var getListingSearchPageData = /*#__PURE__*/function () {
  var _ref13 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee10(data) {
    var isString;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            isString = typeof data === 'string';
            return _context10.abrupt("return", (isString ? _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v2/listing/search").concat(data)) : _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v2/listing/homepage/vitrin"), data)).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function getListingSearchPageData(_x8) {
    return _ref13.apply(this, arguments);
  };
}();
var getListingSearchData = /*#__PURE__*/function () {
  var _ref14 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee11(data) {
    var isString;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            isString = typeof data === 'string';
            return _context11.abrupt("return", (isString ? _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing").concat(data), {
              headers: {
                'Cache-Control': 'no-cache, must-revalidate'
              }
            }) : _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/homepage/showcase?filtreler=vitrin-turu=homepage"), data)).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getListingSearchData(_x9) {
    return _ref14.apply(this, arguments);
  };
}();
var getShowcaseListings = /*#__PURE__*/function () {
  var _ref15 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee12() {
    var page,
        pageSize,
        _args12 = arguments;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            page = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : 0;
            pageSize = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : 18;
            return _context12.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/homepage/showcase/").concat(page, "?filtreler=vitrin-turu=homepage&pageSize=").concat(pageSize)).then(function (response) {
              return response.data;
            }));

          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getShowcaseListings() {
    return _ref15.apply(this, arguments);
  };
}();
var getProjectListingSearchData = /*#__PURE__*/function () {
  var _ref16 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee13(data) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/project").concat(data)).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getProjectListingSearchData(_x10) {
    return _ref16.apply(this, arguments);
  };
}();
var getNearbyPOIs = /*#__PURE__*/function () {
  var _ref18 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee14(_ref17) {
    var listingId, categories, limit;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            listingId = _ref17.listingId, categories = _ref17.categories, limit = _ref17.limit;
            return _context14.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/listing/").concat(listingId, "/nearby-poi"), {
              params: {
                category: categories.join(','),
                limit: limit
              }
            }).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getNearbyPOIs(_x11) {
    return _ref18.apply(this, arguments);
  };
}();
var getSimilarListings = /*#__PURE__*/function () {
  var _ref20 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee15(_ref19) {
    var listingId, _ref19$limit, limit, _ref19$accountOnly, accountOnly;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            listingId = _ref19.listingId, _ref19$limit = _ref19.limit, limit = _ref19$limit === void 0 ? 20 : _ref19$limit, _ref19$accountOnly = _ref19.accountOnly, accountOnly = _ref19$accountOnly === void 0 ? false : _ref19$accountOnly;
            return _context15.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/similar/").concat(listingId), {
              params: {
                accountOnly: accountOnly,
                limit: limit
              }
            }).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function getSimilarListings(_x12) {
    return _ref20.apply(this, arguments);
  };
}();
var getNearByListings = /*#__PURE__*/function () {
  var _ref21 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee16(listingId) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/seo/").concat(listingId, "/near-by-listings")).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function getNearByListings(_x13) {
    return _ref21.apply(this, arguments);
  };
}();
var viewListingDetailEvent = /*#__PURE__*/function () {
  var _ref22 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee17(listingId) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/listing/").concat(listingId, "/view-detail")).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function viewListingDetailEvent(_x14) {
    return _ref22.apply(this, arguments);
  };
}();
var handleViewPhoneEvent = /*#__PURE__*/function () {
  var _ref23 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee18(listingId, type) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/listing/").concat(listingId, "/view-phone?reason=").concat(type)).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function handleViewPhoneEvent(_x15, _x16) {
    return _ref23.apply(this, arguments);
  };
}();
var getSameRealEstate = /*#__PURE__*/function () {
  var _ref25 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee19(_ref24) {
    var listingId, _ref24$limit, limit;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            listingId = _ref24.listingId, _ref24$limit = _ref24.limit, limit = _ref24$limit === void 0 ? 10 : _ref24$limit;
            return _context19.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/same-real-estate/").concat(listingId, "?"), {
              params: {
                limit: limit
              }
            }).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function getSameRealEstate(_x17) {
    return _ref25.apply(this, arguments);
  };
}();
var getRegionPrice = /*#__PURE__*/function () {
  var _ref26 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee20(searchUrl) {
    var url;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            url = "".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/region-price").concat(searchUrl);
            return _context20.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get(url).then(function (response) {
              return response.data;
            }));

          case 2:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function getRegionPrice(_x18) {
    return _ref26.apply(this, arguments);
  };
}();
var getShowcaseData = /*#__PURE__*/function () {
  var _ref28 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee21(_ref27) {
    var type, _ref27$sorting, sorting, _ref27$pageSize, pageSize, categoryType, selectedCategory, params, url, _yield$axiosInstance$, data;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            type = _ref27.type, _ref27$sorting = _ref27.sorting, sorting = _ref27$sorting === void 0 ? 1 : _ref27$sorting, _ref27$pageSize = _ref27.pageSize, pageSize = _ref27$pageSize === void 0 ? 28 : _ref27$pageSize, categoryType = _ref27.categoryType;
            selectedCategory = categoryType ? "/".concat(categoryType.replace(/^\/+|\/+$/g, '')) : '';
            params = new URLSearchParams({
              vitrin_turu: type,
              siralama: sorting,
              pageSize: pageSize
            });
            url = "".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/listing/homepage/showcase").concat(selectedCategory, "?filtreler=vitrin-turu=homepage&").concat(params);
            _context21.next = 6;
            return _config_axiosInstance__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get(url);

          case 6:
            _yield$axiosInstance$ = _context21.sent;
            data = _yield$axiosInstance$.data;
            return _context21.abrupt("return", data);

          case 9:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function getShowcaseData(_x19) {
    return _ref28.apply(this, arguments);
  };
}();

/***/ })

}]);